import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const EASE = [0.23, 1, 0.32, 1] as const;
interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  /** Sticky action row pinned to the bottom of the panel. */
  footer?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Right-hand detail panel. Slides in on desktop, rises from the bottom on
 * phones where a side sheet would be too narrow to read.
 */
export function SidePanel({
  isOpen,
  onClose,
  title,
  subtitle,
  footer,
  children
}: SidePanelProps) {
  return <AnimatePresence data-id="element-190" data-mp="5vgf4q8mylvt">
      {isOpen && <div role="dialog" aria-modal="true" aria-label={title} className="fixed inset-0 z-50" data-id="element-191" data-mp="5sc7fivyp80e">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} onClick={onClose} className="absolute inset-0 bg-stone-900/40" data-id="element-192" data-mp="3s2eq7srh9zgc" />

          <motion.aside initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="absolute inset-y-0 right-0 flex w-full max-w-lg flex-col bg-white shadow-xl" data-id="element-193" data-mp="1x7vr4c8be1yt">
            <header className="flex items-start justify-between gap-4 border-b border-stone-200 px-5 py-4" data-id="element-194" data-mp="1ihoieo83zxbb">
              <div className="min-w-0" data-id="element-195" data-mp="1ehe2ojuilsj9">
                <h2 className="truncate text-lg font-bold tracking-tight text-stone-900" data-id="element-196" data-mp="1eifljahrvjbj">
                  {title}
                </h2>
                {subtitle && <p className="mt-0.5 truncate text-sm text-stone-500" data-id="element-197" data-mp="1ng82ej356z11">
                    {subtitle}
                  </p>}
              </div>
              <button onClick={onClose} aria-label="Luk" className="-mr-1 flex-shrink-0 rounded-lg p-1.5 text-stone-400 transition-colors hover:bg-stone-100 hover:text-stone-700" data-id="element-198" data-mp="usvh0c8pwx9b">
                <XIcon className="h-5 w-5" data-id="element-199" data-mp="2zsn29wx57r3f" />
              </button>
            </header>

            <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5" data-id="element-200" data-mp="34lpotl3i60a4">
              {children}
            </div>

            {footer && <footer className="border-t border-stone-200 px-5 py-4" data-id="element-201" data-mp="39lu97m7j7f5m">
                {footer}
              </footer>}
          </motion.aside>
        </div>}
    </AnimatePresence>;
}